import styled from '@emotion/styled/macro'
import { fontSize } from '@styles/theme'

import { Checkbox, FormControlLabel } from '@mui/material'

const StyledFormControlLabel = styled(FormControlLabel)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const Label = styled.b`
  font-size: ${fontSize('lg')};
  font-weight: 500;
`

// This checkbox works with multi-enum postgres values in the database and expects those values to be in the form of a set instead of an array
const EnumValueCheckbox = ({ label, state, property, name, onChange, slots={ label: {} } }) => {
  const isChecked = state?.[property]?.has?.(name)

  return (
    <StyledFormControlLabel
      label={<Label {...slots?.label}>{label}</Label>}
      control={<Checkbox sx={!isChecked && { '& .MuiSvgIcon-root': { fill: 'grey' } }} />}
      onChange={(e) => onChange(property, e)}
      checked={isChecked}
      name={name}
    />
  )
}

export { EnumValueCheckbox }
